export default __webpack_public_path__ + "static/media/32-icon-equalizer.773b9771.svg";